"use client";

import { useCustomEditor } from "@/providers/custom-editor-provider";
import { BubbleMenu, Editor } from "@tiptap/react";
import { BoldIcon, ItalicIcon, StrikethroughIcon } from "lucide-react";
import { EditorOptionButton } from "./editor-options/editor-option-button";

const EditorBubbleMenu = () => {
	const { editor } = useCustomEditor();

	if (!editor) return null;

	const handleShowBubbleMenu = ({ editor }: { editor: Editor }) => {
		const isCustomImage = editor.isActive("customImage");

		return editor.view.state.selection.content().size > 0 && !isCustomImage;
	};

	return (
		<BubbleMenu editor={editor} tippyOptions={{ duration: 100 }} shouldShow={handleShowBubbleMenu}>
			<div className="rounded-md bg-white p-2 shadow-md">
				<EditorOptionButton
					title="Bold"
					icon={BoldIcon}
					active={editor.isActive("bold")}
					onClick={() => editor.chain().focus().toggleBold().run()}
				/>

				<EditorOptionButton
					title="Italic"
					icon={ItalicIcon}
					active={editor.isActive("italic")}
					onClick={() => editor.chain().focus().toggleItalic().run()}
				/>

				<EditorOptionButton
					title="Strike"
					icon={StrikethroughIcon}
					active={editor.isActive("strike")}
					onClick={() => editor.chain().focus().toggleStrike().run()}
				/>
			</div>
		</BubbleMenu>
	);
};

export default EditorBubbleMenu;
